// Module
var code = "<react-component name=\"EditConsentClause\"></react-component>\n";
// Exports
module.exports = code;